import { useScreen } from "../../contexts/screen.provider";
import { useEffect, useState, useRef } from "react";

export const GoogleInFeedAd = () => {
  const { isDesktop, isTablet, isMobile } = useScreen();
  const [mobileAdBgImage, setMobileAdBgImage] = useState("");
  const [desktopAdBgImage, setDesktopAdBgImage] = useState("");

  const mobileAdsfallbackImages = [
    "/ad_fallback_banners/ad_bg_mobile_001.png",
    "/ad_fallback_banners/ad_bg_mobile_002.png",
    "/ad_fallback_banners/ad_bg_mobile_003.png"
  ];

  const desktopAdsfallbackImages = [
    "/ad_fallback_banners/ad_bg_tablet_001.png",
    "/ad_fallback_banners/ad_bg_tablet_002.png",
    "/ad_fallback_banners/ad_bg_tablet_003.png"
  ];

  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
    }

    const randomIndex = Math.floor(Math.random() * mobileAdsfallbackImages.length);
    setMobileAdBgImage(mobileAdsfallbackImages[randomIndex]);
    setDesktopAdBgImage(desktopAdsfallbackImages[randomIndex]);
  }, []);

  return (
    <>
      {isMobile && (
        <div className="overflow-hidden google-ad bg-center bg-cover border border-gray-300 dark:border-gray-700 bg-white dark:bg-[#212121] shadow-sm"
          style={{
            backgroundImage: `url(${mobileAdBgImage})`,
          }}>
          <ins className="adsbygoogle"
            style={{ display: "block" }}
            data-ad-format="fluid"
            data-ad-layout="in-feed"
            data-ad-layout-key="-6t+ed+2i-1n-4w"
            data-ad-client="ca-pub-9176018929494610"
            data-ad-slot="2491614504">
          </ins>
        </div>
      )}
      {isTablet && (
        <div className="overflow-hidden google-ad bg-center bg-cover border border-gray-300 dark:border-gray-700 bg-white dark:bg-[#212121] shadow-sm"
          style={{
            backgroundImage: `url(${desktopAdBgImage})`,
          }}>
          <ins className="adsbygoogle"
            style={{ display: "block" }}
            data-ad-format="fluid"
            data-ad-layout="in-feed"
            data-ad-layout-key="-fb+5w+4e-db+86"
            data-ad-client="ca-pub-9176018929494610"
            data-ad-slot="1481785167">
          </ins>
        </div>

      )}
      {isDesktop && (
        <div className="overflow-hidden google-ad bg-center bg-cover border border-gray-300 dark:border-gray-700 bg-white dark:bg-[#212121] shadow-sm"
          style={{
            backgroundImage: `url(${desktopAdBgImage})`,
          }}>
          <ins className="adsbygoogle"
            style={{ display: "block" }}
            data-ad-format="fluid"
            data-ad-layout="in-feed"
            data-ad-layout-key="-fb+5w+4e-db+86"
            data-ad-client="ca-pub-9176018929494610"
            data-ad-slot="1481785167">
          </ins>
        </div>
      )}
    </>
  );
}